<div class="container container-wrapper page-container">
  <div class="row justify-content-center">
    <div class="col-xs-12 col-lg-12 col-xl-11">
      <section>
        <div class="row">
          <div *ngIf="isShowCalendar" id="ajax-load-slots-diagram" class="col-sm-6 col-xs-12 slots-diagram p-0">
            <section>
              <!-- <app-time-slot-date-selector (nextDayClick)="nextDayClick()" (prevDayClick)="prevDayClick()" [selectedDate]="selectedDate"
                [calendarService]="bookingSlotStateService"></app-time-slot-date-selector> -->
              <app-time-slot-calendar (monthChanged)="monthChanged($event)" (dateSelected)="dateSelected($event)"
                [calendarService]="bookingSlotStateService"></app-time-slot-calendar>
              <app-time-slot-diagram *ngIf="showBookingSlotsDiagram"></app-time-slot-diagram>
            </section>
          </div>
          <div class="col-xs-12 slots-time" [ngClass]="{'col-sm-6': isShowCalendar, 'col-sm-12': !isShowCalendar}">
            <div class="slots-header">
              <h3>{{ 'Start at' | translate }}</h3>
            </div>
            <div *ngIf="!isLoading && (!displayTimeSlots || displayTimeSlots.length === 0)" class="container noselect no-slots-message">
              <div class="row justify-content-center">
                <div class="col-12 font-weight-bold">
                  <p *ngIf="!isVUMode">
                    {{ 'Unfortunately, there are no tickets available on this day. Please select another day.' | translate }}
                  </p>
                  <p *ngIf="isVUMode">
                    {{ 'Unfortunately, there are no tickets available on this day.' | translate }}
                  </p>
                </div>
              </div>
            </div>
            <div class="slots-time-box">
              <app-time-slot-navigation *ngIf="showBookingSlotsDiagram"></app-time-slot-navigation>
              <div class="container">
                <app-time-slots *ngIf="displayTimeSlots.length > 0" [timeSlots]="displayTimeSlots"
                  [extraSmallContainer]="!!description"
                  (timeSlotSelected)="onClickTimeSlot($event)"></app-time-slots>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!isLoading && description" class="description-container row">
          <div class="description">{{ description  | translate }}</div>
        </div>
        <div *ngIf="!isLoading" class="row navigation-row">
          <div class="col-12 p-0">
            <div class="container p-0">
              <span>
                <app-backward-forward (backwardClick)="onBack()" [hideNext]="true">
                </app-backward-forward>
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
